import { envConfig } from '@/config/envConfig';
import { ResponseModel } from '../models';

const getBody = <T>(c: Response | Request): Promise<T> => {
  const contentType = c.headers.get('content-type');

  if (contentType && contentType.includes('application/json')) {
    return c.json();
  }

  if (contentType && contentType.includes('application/pdf')) {
    return c.blob() as Promise<T>;
  }

  return c.text() as Promise<T>;
};

const getBaseUrl = (): string => {
  let baseUrl = envConfig.apiBasePath;

  if (typeof window === 'undefined') {
    baseUrl = `${envConfig.apiEndpoint}${envConfig.apiBasePath}`;
  }

  if (!baseUrl) {
    throw new Error(
      `API base URL not configured for ${
        envConfig.isDev ? 'development' : 'production'
      } environment`
    );
  }

  return baseUrl;
};

export async function fetcher<T extends ResponseModel<unknown>>(
  url: string,
  options: RequestInit = {}
): Promise<T> {
  const baseUrl = getBaseUrl();
  const formattedUrl = `${baseUrl}${url}`;

  const response = await fetch(formattedUrl, options);
  const data = await getBody(response);

  return { data, status: response.status } as T;
}
